import { Box } from "@twilio-paste/core/box";
import { useSelector } from "react-redux";

import { AppState, EngagementPhase } from "../../store/definitions";
import { LoadingPhase } from "./LoadingPhase";
import { FormPhase } from "./FormPhase";
import { MessagingPhase } from "./MessagingPhase";
import { ChatHistoryPhase } from "./ChatHistoryPhase";

export function WebChatContainer() {
    const { currentPhase } = useSelector(({ session }: AppState) => ({
        currentPhase: session.currentPhase
    }));

    if (currentPhase === EngagementPhase.Loading) {
        return <Box><LoadingPhase /></Box>;
    }

    if (currentPhase === EngagementPhase.MessagingCanvas) {
        return <Box><MessagingPhase /></Box>;
    }

    // 查看聊天详情时保留表单挂载，避免返回后列表/筛选状态丢失并重新加载
    const showHistory = currentPhase === EngagementPhase.ChatHistory;

    return (
        <Box>
            <Box display={showHistory ? "none" : "block"}>
                <FormPhase />
            </Box>
            {showHistory ? <ChatHistoryPhase /> : null}
        </Box>
    );
}
